const bookingItemTimePeriodPriceReferenceTypes = {
    storageGroupTimePeriodPrice: {},
    additionalServiceTimePeriodPrice: {}
};

Object.keys(bookingItemTimePeriodPriceReferenceTypes).forEach(key => {
    bookingItemTimePeriodPriceReferenceTypes[key].key = key;
});

export default bookingItemTimePeriodPriceReferenceTypes;
